type Props = {
    title: string
    kicker?: string
    image?: string
    imagePosition?: string
    caption?: string
    tint?: boolean // let a little of the photo's colour through instead of full black & white
}

// Full-bleed photo banner when an image is given, plain dark header otherwise
const PageHeader = ({ title, kicker, image, imagePosition = 'center', caption, tint = false }: Props) => (
    <header className={`page-hero ${image ? 'page-hero--image' : ''} ${tint ? 'page-hero--tint' : ''}`}>
        {image && <img className='page-hero__img' src={image} alt='' style={{ objectPosition: imagePosition }} />}
        <div className='page-hero__inner'>
            {kicker && <p className='eyebrow'>{kicker}</p>}
            <h1 className='page-hero__title'>{title}</h1>
        </div>
        {caption && <p className='photo-caption'>{caption}</p>}
    </header>
)

export default PageHeader
